export const FORM_IDENTIFIER = 'app/DeedFormPage';

export const INIT = 'app/DeedFormPage/INIT';
export const INIT_SUCCESS = 'app/DeedFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/DeedFormPage/INIT_FAILED';

export const SAVE_EVENT = 'app/DeedFormPage/SAVE_EVENT';
export const SAVE_CAMPAIGN = 'app/DeedFormPage/SAVE_CAMPAIGN';
export const SAVE_PROJECT = 'app/DeedFormPage/SAVE_PROJECT';

export const SAVE_SUCCESS = 'app/DeedFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/DeedFormPage/SAVE_FAILED';

export const INCREMENT_STEPPER = 'app/DeedFormPage/INCREMENT_STEPPER';
export const SET_STEPPER = 'app/DeedFormPage/SET_STEPPER';

export const FILE_UPLOADED = 'app/DeedFormPage/FILE_UPLOADED';

export const FETCH_PARTNERS = 'app/FormPartnerSelector/FETCH_PARTNERS';
export const FETCH_PARTNERS_SUCCESS = 'app/FormPartnerSelector/FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILED = 'app/FormPartnerSelector/FETCH_PARTNERS_FAILED';

export const TRACK_EVENT_COMMUNITY_DEEDS = 'app/DeedFormPage/TRACK_EVENT_COMMUNITY_DEEDS';
